/**
 * Create a function to update the existing map with a providerDetail key and its resolved value
 * Sample mapping Obj
 * mappings: {
 * 	providerComponent{
 * 		providerProp: resolvedValue
 * 		}
 * }
 * @param resolvedMappings
 * @returns {(function(*, *): void)}
 */
export default function createAddResolvedPropertyMapping(resolvedMappings) {
	return function addResolvedPropertyMapping(providerDetail, resolvedValue) {
		const {providerId, providerPropName} = providerDetail;
		if (!resolvedMappings.has(providerId)) resolvedMappings.set(providerId, new Map());
		resolvedMappings.get(providerId).set(providerPropName, resolvedValue);
	};
}
